import xhr from './../../utils/xhr';

const alertEditApi = {

    getAlertData: (alertId) => {
        return xhr.get({
            url: '/api/alerts/alert/' + alertId
        })
    }

};

export default alertEditApi;


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsEdit/AlertsEdit.api.js